export function computeEconomics(app) {
  const income = app.income || { adults: [], others: [] };
  let gross = 0;
  for (const a of income.adults || []) {
    const used = a.income_used != null ? a.income_used : (a.income_declared || 0);
    gross += Number(used) || 0;
  }
  for (const o of income.others || []) gross += Number(o.amount) || 0;
  let expenses = 0;
  for (const e of app.expenses || []) {
    if (e.status !== "rejected") expenses += Number(e.amount) || 0;
  }
  const adjusted = Math.max(gross - expenses, 0);
  return { gross, expenses, adjusted };
}
